import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, from, Observable, switchMap, throwError} from "rxjs";
import {AuthService} from "./auth.service";

@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isSecuredHost(request.url)) {
      return from(this.addAuthToken(request))
        .pipe(
          switchMap((updatedRequest) => {
            return this.processRequest(updatedRequest, next);
          }));
    } else {
      return this.processRequest(request, next);
    }
  }

  private async addAuthToken(request: HttpRequest<unknown>): Promise<HttpRequest<unknown>> {
    const token: string = await this.authService.getClientSideToken(); //TODO maybe add error handling
    if (!token) {
      return request;
    }

    let clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return clonedRequest
  }


  private isSecuredHost(url: string): boolean {
    return this.authService.securedHosts.some(n => url.includes(n));
  }

  private processRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => {
      return this.handleResponseError(error, request, next);
    }));
  }

  private handleResponseError(err: Error, request: HttpRequest<any>, next: HttpHandler) {
    // 401 error should not happen because teams always gives the latest token back
    return throwError(err);
  }

}
